import { render, staticRenderFns } from "./checkHouse.vue?vue&type=template&id=48152513&scoped=true&"
import script from "./checkHouse.vue?vue&type=script&lang=js&"
export * from "./checkHouse.vue?vue&type=script&lang=js&"
import style0 from "./checkHouse.vue?vue&type=style&index=0&id=48152513&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48152513",
  null
  
)

export default component.exports